import { useCallback, useRef } from 'react';

const useThrottle = (cb, limit = 500) => {
  const lastRun = useRef(0);

  return useCallback(
    (...args) => {
      const now = Date.now();
      if (now - lastRun.current >= limit) {
        cb(...args);
        lastRun.current = now;
      }
    },
    [cb, limit]
  );
};

export default useThrottle;
